import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../app_components/StandardModal'
import Icon from '../app_components/Icon'
import LoaderSection from '../app_components/LoaderSection'
import { semantic } from '@lexody/design-tokens'
import dateTimeFormat from '../utils/dateTimeFormat'

class LexicoinHistory extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      lexicoins: this.props.lexicoins,
      history: [],
      loading: true,
    }

    this.renderHistory = this.renderHistory.bind(this)
  }

  componentDidMount() {
    $.ajax({
      url: `../getLexicoinHistory`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          history: JSON.parse(data.data.lexicoin_records),
          loading: false,
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
        this.setState({ loading: false })
      }.bind(this)
    });
  }

  renderCoinIcon() {
    if (this.props.lexicoinIcon) {
      return (
        <img
          src={this.props.lexicoinIcon}
          alt=""
          className="lexicoin-history-modal__coinImg"
        />
      )
    }

    return <span className="lexicoin-history-modal__coinImg lexicoin" aria-hidden="true" />
  }

  renderHistory() {
    if (this.state.loading) {
      return <LoaderSection />
    }

    if (this.state.history.length === 0) {
      return (
        <p className="lexicoin-history-modal__empty">
          No Lexicoin activity yet. Earn coins by completing Lexes and other actions on Lexody.
        </p>
      )
    }

    return this.state.history.map((history, i) => {
      const { increase, points, description, record_date } = history
      const isIncrease = increase === true
      const toneClass = isIncrease
        ? 'lexicoin-history-modal__row--increase'
        : 'lexicoin-history-modal__row--decrease'

      return(
        <div
          key={i}
          className={`lexicoin-history-modal__row ${toneClass}`}
        >
          <div className="lexicoin-history-modal__rowIcon" aria-hidden="true">
            {points != null &&
              <Icon
                name={isIncrease ? 'arrow-up' : 'arrow-down'}
                size={16}
                color={isIncrease ? semantic.primary.surface.default : semantic.warning.surface.default}
              />
            }
          </div>
          <div className="lexicoin-history-modal__rowBody">
            <p className="lexicoin-history-modal__rowDescription">{description}</p>
            <p className="lexicoin-history-modal__rowDate">{dateTimeFormat(record_date)}</p>
          </div>
          {points != null &&
            <p className="lexicoin-history-modal__rowPoints">
              {isIncrease ? '+' : '-'}{points} lexicoin{points === 1 ? '' : 's'}
            </p>
          }
        </div>
      )
    })
  }

  render() {
    return(
      <StandardModal
        onClose={this.props.onClose}
        title="My Lexicoin History"
        size="wide"
      >
        <div className="lexicoin-history-modal">
          <div className="lexicoin-history-modal__hero">
            <div className="lexicoin-history-modal__coin" aria-hidden="true">
              {this.renderCoinIcon()}
            </div>
            <div className="lexicoin-history-modal__balance">
              <p className="lexicoin-history-modal__count">{this.state.lexicoins}</p>
              <p className="lexicoin-history-modal__label">lexicoins</p>
            </div>
          </div>
          <div className="lexicoin-history-modal__list">
            {this.renderHistory()}
          </div>
        </div>
      </StandardModal>
    )
  }

}

LexicoinHistory.propTypes = {
  lexicoins: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  lexicoinIcon: PropTypes.string,
  onClose: PropTypes.func.isRequired,
}

export default LexicoinHistory
